import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRight, Handshake, FileSignature, DollarSign } from 'lucide-react';
export function DealsContractsPage() {
  return <div className="pt-32 pb-20" data-id="element-6020">
      {/* Hero */}
      <section className="max-w-4xl mx-auto px-6 text-center mb-24" data-id="element-6021">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-5xl md:text-6xl font-bold tracking-tight mb-6 leading-tight" data-id="element-6022">
          Move from conversation to confirmed booking without losing the thread.
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-xl text-textMuted mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-6023">
          Track every offer, hold, contract, invoice, deposit, and settlement in
          one structured workflow with approvals built in.
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} data-id="element-6024">
          <button className="inline-flex items-center gap-2 px-8 py-4 text-base font-medium text-textMain border border-border rounded-lg hover:bg-surface transition-colors" data-id="element-6025">
            Book a demo
            <ChevronRight className="w-4 h-4" data-id="element-6026" />
          </button>
        </motion.div>
      </section>

      {/* Features */}
      <section className="max-w-6xl mx-auto px-6" data-id="element-6027">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-6028">
          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-6029">
            <Handshake className="w-8 h-8 text-primary mb-6" data-id="element-6030" />
            <h3 className="text-xl font-semibold mb-3" data-id="element-6031">Deal Stages & Holds</h3>
            <p className="text-textMuted mb-6" data-id="element-6032">
              Visualize your entire pipeline. Track which deals are in
              negotiation, which dates have holds, and what needs your attention
              today.
            </p>
            <div className="space-y-2" data-id="element-6033">
              <div className="px-3 py-2 bg-background border border-border rounded text-sm flex justify-between" data-id="element-6034">
                <span data-id="element-6035">Offer Received</span>
                <span className="text-primary font-medium" data-id="element-6036">3</span>
              </div>
              <div className="px-3 py-2 bg-background border border-border rounded text-sm flex justify-between" data-id="element-6037">
                <span data-id="element-6038">Hold (Expiring soon)</span>
                <span className="text-amber-500 font-medium" data-id="element-6039">1</span>
              </div>
            </div>
          </div>

          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-6040">
            <FileSignature className="w-8 h-8 text-primary mb-6" data-id="element-6041" />
            <h3 className="text-xl font-semibold mb-3" data-id="element-6042">Contract Assembly</h3>
            <p className="text-textMuted mb-6" data-id="element-6043">
              Generate contracts automatically from deal terms. Use your
              templates, manage clause libraries, and collect e-signatures
              seamlessly.
            </p>
            <div className="space-y-2" data-id="element-6044">
              <div className="px-3 py-2 bg-background border border-border rounded text-sm flex items-center gap-2" data-id="element-6045">
                <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-6046"></div>
                Standard Performance Contract
              </div>
              <div className="px-3 py-2 bg-background border border-border rounded text-sm flex items-center gap-2" data-id="element-6047">
                <div className="w-2 h-2 rounded-full bg-blue-500" data-id="element-6048"></div>
                Festival Rider Template
              </div>
            </div>
          </div>

          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-6049">
            <DollarSign className="w-8 h-8 text-primary mb-6" data-id="element-6050" />
            <h3 className="text-xl font-semibold mb-3" data-id="element-6051">Invoices & Deposits</h3>
            <p className="text-textMuted mb-6" data-id="element-6052">
              Never lose track of a deposit again. Automatically generate
              invoices, track payment status, and monitor aged receivables.
            </p>
            <div className="space-y-2" data-id="element-6053">
              <div className="px-3 py-2 bg-background border border-border rounded text-sm flex justify-between" data-id="element-6054">
                <span data-id="element-6055">Deposit: The Empty Bottle</span>
                <span className="text-green-500 font-medium" data-id="element-6056">Paid</span>
              </div>
              <div className="px-3 py-2 bg-background border border-border rounded text-sm flex justify-between" data-id="element-6057">
                <span data-id="element-6058">Deposit: Beachland Tavern</span>
                <span className="text-amber-500 font-medium" data-id="element-6059">Overdue</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}